export default (state = { enabled: false, faseActivacion: null }, action = {}) => {
  switch (action.type) {
    case 'WILDCARD_MODE_ENABLE':
      return {
        enabled: true,
        faseActivacion: action.payload?.faseActivacion || null
      };
    case 'WILDCARD_MODE_DISABLE':
      return { enabled: false, faseActivacion: null };
    case 'AUTH_CLEAR':
      return { enabled: false, faseActivacion: null };
    default:
      return state;
  }
};
